import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { globalActions, categoriesActions, sponsorStatisticActions } from '../../actions';
import { Dashboard } from '../../components';

const mapStateToProps = state => {
  return {
    globalState: state.globalState,
    categories: state.categoriesState.categories,
    user: state.authState.user
  };
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(globalActions, dispatch),
    categoriesActions: bindActionCreators(categoriesActions, dispatch),
    setSponsorStatistic: bindActionCreators(sponsorStatisticActions.setStatistic, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);